module.exports = __webpack_public_path__ + "img/hand_diamonds.fe9eaf4f.png";